<div class="filter-bar">
  <ng-content select="[filter-bar-front]"></ng-content>
  <div class="filter-chips">
    @if (text === true) {
      <framework-simple-search-input
        [searchText]="filteredText.length > 0 ? filteredText[0].value : ''"
        (searchTextChange)="textChanged($event)"
        >
      </framework-simple-search-input>
    }

    <!-- <shared-definition-id-input
    [definitionId]="filteredDefinitionId[0]?.value ?? ''"
    (definitionIdChange)="definitionIdChanged($event)"
    *ngIf="definitionId === true"
    >
  </shared-definition-id-input> -->

  @for (roFilter of readOnlyFilters; track roFilter) {
    @if (roFilter.type !== 'status') {
      <elements-filter-chip
        [icon]="iconFromFilterType(roFilter)"
        [caption]="roFilter.displayName"
        [selected]="true"
        [disabled]="true"
        >
      </elements-filter-chip>
    } @else {
      <framework-work-status-chip [workStatus]="{ id: roFilter.value, displayName: roFilter.displayName }">
      </framework-work-status-chip>
    }
  }

  @for (product of filteredContentTypes; track product) {
    <elements-filter-chip
      icon="category"
      [caption]="product.displayName"
      [selected]="true"
      (click)="openFilterPanel('Content Type')"
      >
    </elements-filter-chip>
  }

  @for (definitionId of filteredDefinitionId; track definitionId) {
    <elements-filter-chip
      icon="category"
      [caption]="definitionId.displayName"
      [selected]="true"
      (click)="openFilterPanel('DefinitionId')"
      >
    </elements-filter-chip>
  }

  @for (tag of filteredTags; track tag) {
    <elements-filter-chip
      icon="sell"
      [caption]="tag.displayName"
      [selected]="true"
      (click)="openFilterPanel('Tags')"
      >
    </elements-filter-chip>
  }

  @for (campaign of filteredCampaigns; track campaign) {
    <elements-filter-chip
      icon="campaign"
      [caption]="campaign.displayName"
      [selected]="true"
      (click)="openFilterPanel('Campaign')"
      >
    </elements-filter-chip>
  }

  @for (status of filteredStatuses; track status) {
    <framework-work-status-chip
      [workStatus]="{ id: status.value, displayName: status.displayName }"
      (click)="projectStatuses === true ?  openFilterPanel('ProjectStatus') : openFilterPanel('Status')"
      >
    </framework-work-status-chip>
  }

  @for (sow of filteredSows; track sow) {
    <elements-filter-chip
      icon="receipt"
      [caption]="sow.displayName"
      [selected]="true"
      (click)="openFilterPanel('Sow')"
      >
    </elements-filter-chip>
  }

  @for (owner of filteredOwners; track owner) {
    <elements-filter-chip
      icon="person"
      [caption]="owner.displayName"
      [selected]="true"
      (click)="openFilterPanel('Owner')"
      >
    </elements-filter-chip>
  }

  @for (owner of filteredOwnersByTeam; track owner) {
    <elements-filter-chip
      icon="person"
      [caption]="owner.displayName"
      [selected]="true"
      (click)="openFilterPanel('OwnerTeam')"
      >
    </elements-filter-chip>
  }

  @for (team of filteredTeams; track team) {
    <elements-filter-chip
      icon="people"
      [caption]="team.displayName"
      [selected]="true"
      (click)="openFilterPanel('Team')"
      >
    </elements-filter-chip>
  }

  @for (month of filteredMonths; track month) {
    <elements-filter-chip
      icon="receipt"
      [caption]="month.displayName"
      [selected]="true"
      (click)="openFilterPanel('Month')"
      >
    </elements-filter-chip>
  }

  @for (department of filteredDepartments; track department) {
    <elements-filter-chip
      icon="groups_2"
      [caption]="department.displayName"
      [selected]="true"
      (click)="openFilterPanel('Department')"
      >
    </elements-filter-chip>
  }

  @for (org of filteredOrganizations; track org) {
    <elements-filter-chip
      icon="corporate_fare"
      [caption]="org.displayName"
      [selected]="true"
      (click)="openFilterPanel('Organization')"
      >
    </elements-filter-chip>
  }

  @for (org of filteredIndustrySectors; track org) {
    <elements-filter-chip
      icon="factory"
      [caption]="org.displayName"
      [selected]="true"
      (click)="openFilterPanel('IndustrySector')"
      >
    </elements-filter-chip>
  }

  @for (template of filteredTemplates; track template) {
    <elements-filter-chip
      icon="view_timeline"
      [caption]="template.displayName"
      [selected]="true"
      (click)="openFilterPanel('Template')"
      >
    </elements-filter-chip>
  }

  @for (productClass of filteredProductClasses; track productClass) {
    <elements-filter-chip
      icon="category"
      [caption]="productClass.displayName"
      [selected]="true"
      (click)="openFilterPanel('ProductClass')"
      >
    </elements-filter-chip>
  }

  @for (unit of filteredUnits; track unit) {
    <elements-filter-chip
      icon="star"
      [caption]="unit.displayName"
      [selected]="true"
      (click)="openFilterPanel('Unit')"
      >
    </elements-filter-chip>
  }

  @for (sowType of filteredSowTypes; track sowType) {
    <elements-filter-chip
      icon="receipt"
      [caption]="sowType.displayName"
      [selected]="true"
      (click)="openFilterPanel('SowType')"
      >
    </elements-filter-chip>
  }

  @for (paceOffset of filteredPaceOffset; track paceOffset) {
    <elements-filter-chip
      icon="star"
      [caption]="paceOffset.displayName"
      [selected]="true"
      (click)="openFilterPanel('PaceOffset')"
      >
    </elements-filter-chip>
  }

  @for (dateRage of filteredDateRange; track dateRage) {
    <elements-filter-chip
      icon="event"
      [caption]="dateRage.displayName"
      [selected]="true"
      (click)="openFilterPanel('DateRange')"
      >
    </elements-filter-chip>
  }

  @for (option of selectedViewOptions; track option) {
    <elements-view-option-chip
      [icon]="option.icon || 'data_thresholding'"
      [caption]="option.displayName"
      [selected]="true"
      (click)="openOptionPanel(option)"
      >
    </elements-view-option-chip>
  }

  <div class="results-count">
    @if (resultsCount) {
      SHOWING {{ resultsCount | number : '1.0-0' }} {{ filterCount > 0 ? "FILTERED" : "" }} RESULTS
    }
    <ng-content select="[results-info]"></ng-content>
  </div>
</div>

<ng-content select="[other-buttons]"></ng-content>
@if (hasFilters) {
  <button styles-low-button icon="filter_list" [matMenuTriggerFor]="filterMenu">Filter</button>
}

<mat-menu #filterMenu="matMenu">
  <button mat-menu-item disabled>FILTER BY</button>
  @if (tags) {
    <button mat-menu-item (click)="openFilterPanel('Tags')">
      <mat-icon>tag</mat-icon>
      Tags
    </button>
  }
  @if (contentTypes) {
    <button mat-menu-item (click)="openFilterPanel('Content Type')">
      <mat-icon>category</mat-icon>
      Content Type
    </button>
  }
  @if (definitionId) {
    <button mat-menu-item (click)="openFilterPanel('DefinitionId')">
      <mat-icon>filter</mat-icon>
      Definition Id
    </button>
  }
  @if (campaigns) {
    <button mat-menu-item (click)="openFilterPanel('Campaign')">
      <mat-icon>campaign</mat-icon>
      Campaign
    </button>
  }
  @if (statuses) {
    <button mat-menu-item (click)="openFilterPanel('Status')">
      <mat-icon>traffic</mat-icon>
      Status
    </button>
  }
  @if (projectStatuses) {
    <button mat-menu-item (click)="openFilterPanel('ProjectStatus')">
      <mat-icon>traffic</mat-icon>
      Status
    </button>
  }
  @if (sows) {
    <button mat-menu-item (click)="openFilterPanel('Sow')">
      <mat-icon>receipt</mat-icon>
      Statement of Work
    </button>
  }
  @if (owners) {
    <button mat-menu-item (click)="openFilterPanel('Owner')">
      <mat-icon>person</mat-icon>
      Ownership
    </button>
  }
  @if (ownersByTeam) {
    <button mat-menu-item (click)="openFilterPanel('OwnerTeam')">
      <mat-icon>person</mat-icon>
      Ownership
    </button>
  }
  @if (months) {
    <button mat-menu-item (click)="openFilterPanel('Month')">
      <mat-icon>event</mat-icon>
      Month
    </button>
  }
  @if (teams) {
    <button mat-menu-item (click)="openFilterPanel('Team')">
      <mat-icon>people</mat-icon>
      Team
    </button>
  }
  @if (departments) {
    <button mat-menu-item (click)="openFilterPanel('Department')">
      <mat-icon>groups_2</mat-icon>
      Department
    </button>
  }
  @if (organizations) {
    <button mat-menu-item (click)="openFilterPanel('Organization')">
      <mat-icon>corporate_fare</mat-icon>
      Organization
    </button>
  }
  @if (industrySectors) {
    <button mat-menu-item (click)="openFilterPanel('IndustrySector')">
      <mat-icon>factory</mat-icon>
      Industry Sector
    </button>
  }
  @if (productClasses) {
    <button mat-menu-item (click)="openFilterPanel('ProductClass')">
      <mat-icon>category</mat-icon>
      Product Class
    </button>
  }
  @if (templates) {
    <button mat-menu-item (click)="openFilterPanel('Template')">
      <mat-icon>view_timeline</mat-icon>
      Product Template
    </button>
  }
  @if (units) {
    <button mat-menu-item (click)="openFilterPanel('Unit')">
      <mat-icon>star</mat-icon>
      Units
    </button>
  }
  @if (sowTypes) {
    <button mat-menu-item (click)="openFilterPanel('SowType')">
      <mat-icon>receipt</mat-icon>
      SOW Types
    </button>
  }
  @if (paceOffset) {
    <button mat-menu-item (click)="openFilterPanel('PaceOffset')">
      <mat-icon>star</mat-icon>
      Pace Offset
    </button>
  }
  @if (dateRange) {
    <button mat-menu-item (click)="openFilterPanel('DateRange')">
      <mat-icon>event</mat-icon>
      Date Range
    </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="clearAll()">
    <mat-icon>cancel</mat-icon>
    Clear All
  </button>
  @if (viewOptions) {
    <mat-divider></mat-divider>
    <button mat-menu-item disabled>VIEW BY</button>
    @for (option of getUniqueViewOptions(viewOptions); track option) {
      <button mat-menu-item (click)="openOptionPanel(option)">
        <mat-icon>{{ option.icon }}</mat-icon>
        {{ option.typeName }}
      </button>
    }
  }
  @if (versionOptions) {
    <mat-divider></mat-divider>
    <button mat-menu-item disabled>VIEW BY</button>
    @for (versionOption of getUniqueVersionOptions(versionOptions); track versionOption) {
      <button
        mat-menu-item
        (click)="openOptionPanel(versionOption)"
        >
        <mat-icon>{{ versionOption.icon }}</mat-icon>
        {{ versionOption.typeName }}
      </button>
    }
  }
  @if (navOptions && navOptions.length > 0) {
    <mat-divider></mat-divider>
    <button mat-menu-item disabled>SWITCH TO</button>
    @for (option of navOptions; track option) {
      <button mat-menu-item [routerLink]="option.route">
        <mat-icon>{{ option.icon }}</mat-icon>
        {{ option.caption }}
      </button>
    }
  }
</mat-menu>
</div>

@if (filterOption === 'Tags') {
  <shared-filter-panel-tags
    class="panel"
    [(tags)]="filteredTags"
    [feedId]="feedId"
    [parentTagId]="parentTagId"
    (tagsChange)="filterTagChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-tags>
}

@if (filterOption === 'Sow') {
  <shared-filter-panel-sows
    class="panel"
    [(sows)]="filteredSows"
    [feedId]="feedId"
    (sowsChange)="filterSowChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-sows>
}

@if (filterOption === 'Status') {
  <shared-filter-panel-status
    class="panel"
    [(statuses)]="filteredStatuses"
    (statusesChange)="filterStatusChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-status>
}

@if (filterOption === 'ProjectStatus') {
  <shared-filter-panel-project-status
    class="panel"
    [(statuses)]="filteredStatuses"
    (statusesChange)="filterStatusChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-project-status>
}

@if (filterOption === 'Content Type') {
  <shared-filter-panel-content-type
    class="panel"
    [(products)]="filteredContentTypes"
    (productsChange)="filterContentTypeChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-content-type>
}

@if (filterOption === 'DefinitionId') {
  <shared-filter-panel-definition-id
    class="panel"
    [(definitionId)]="filteredDefinitionId"
    (definitionIdChange)="filteredDefinitionIdChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-definition-id>
}

@if (filterOption === 'Template') {
  <shared-filter-panel-templates
    class="panel"
    [(templates)]="filteredTemplates"
    (templatesChange)="filterTemplateChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-templates>
}

@if (filterOption === 'ProductClass') {
  <shared-filter-panel-product-classes
    class="panel"
    [(productClasses)]="filteredProductClasses"
    (productClassesChange)="filterProductClassChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-product-classes>
}

@if (filterOption === 'IndustrySector') {
  <shared-filter-panel-industry-sectors
    class="panel"
    [(industrySectors)]="filteredIndustrySectors"
    (industrySectorsChange)="filterIndustrySectorChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-industry-sectors>
}

@if (filterOption === 'Month') {
  <shared-filter-panel-months
    class="panel"
    [(months)]="filteredMonths"
    (monthsChange)="clearChangedDate('month')"
    (close)="closePanels()"
    >
  </shared-filter-panel-months>
}

@if (filterOption === 'Owner') {
  <shared-filter-panel-owners
    class="panel"
    [(owners)]="filteredOwners"
    (ownersChange)="filterOwnerChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-owners>
}

@if (filterOption === 'OwnerTeam') {
  <shared-filter-panel-owners-by-team
    class="panel"
    [teamId]="teamId"
    [(owners)]="filteredOwnersByTeam"
    (ownersChange)="filterOwnerbyTeamChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-owners-by-team>
}

@if (filterOption === 'Team') {
  <shared-filter-panel-teams
    class="panel"
    [(teams)]="filteredTeams"
    (teamsChange)="filterTeamChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-teams>
}

@if (filterOption === 'Department') {
  <shared-filter-panel-departments
    class="panel"
    [(departments)]="filteredDepartments"
    (departmentsChange)="filterDepartmentChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-departments>
}

@if (filterOption === 'Organization') {
  <shared-filter-panel-organizations
    class="panel"
    [(organizations)]="filteredOrganizations"
    (organizationsChange)="filterOrganizationChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-organizations>
}

@if (filterOption === 'Campaign') {
  <shared-filter-panel-campaigns
    class="panel"
    [feedId]="feedId"
    [(campaigns)]="filteredCampaigns"
    (campaignsChange)="filterCampaignChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-campaigns>
}

@if (filterOption === 'Unit') {
  <shared-filter-panel-units
    class="panel"
    [(units)]="filteredUnits"
    (unitsChange)="filterUnitChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-units>
}

@if (filterOption === 'SowType') {
  <shared-filter-panel-sow-type
    class="panel"
    [(sowTypes)]="filteredSowTypes"
    (sowTypesChange)="filterSowTypeChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-sow-type>
}

@if (filterOption === 'PaceOffset') {
  <shared-filter-panel-pace-offset
    class="panel"
    [(paceOffset)]="filteredPaceOffset"
    (paceOffsetChange)="filteredPaceOffsetChanged()"
    (close)="closePanels()"
    >
  </shared-filter-panel-pace-offset>
}

@if (filterOption === 'DateRange') {
  <shared-filter-panel-date-range
    class="panel"
    [(dateRange)]="filteredDateRange"
    (dateRangeChange)="clearChangedDate('dateRange')"
    (close)="closePanels()"
    >
  </shared-filter-panel-date-range>
}

@if (viewOption) {
  <framework-view-options-panel
    class="panel"
    [viewOptions]="getViewTypeOptions(viewOptions, viewOption.type)"
    [(selectedOptions)]="selectedViewOptions"
    (selectedOptionsChange)="selectedViewOptionsChanged(viewOption.type)"
    (close)="closePanels()"
    >
  </framework-view-options-panel>
}

<!-- <framework-view-options-panel
class="panel"
*ngIf="versionOption"
[viewOptions]="getViewTypeOptions(versionOptions, viewOption.type)"
[(selectedOptions)]="selectedVersionOptions"
(selectedOptionsChange)="selectedVersionOptionsChanged(viewOption.type)"
(close)="closePanels()"
>
</framework-view-options-panel> -->
